module.exports = __webpack_public_path__ + "static/media/traffic-cone.8dc77bee.svg";